(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["obor-product-share"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.currentScript?.closest('.obor-product-share');
    if (!root) return;

    const button = root.querySelector('[data-obor-share]');
    const status = root.querySelector('[data-obor-share-status]');
    if (!button || button.dataset.oborShareBound === 'true') return;
    button.dataset.oborShareBound = 'true';

    function setStatus(text) {
      if (!status) return;
      status.textContent = text || '';
      if (text) {
        window.clearTimeout(status.__oborTimer);
        status.__oborTimer = window.setTimeout(() => {
          status.textContent = '';
        }, 2500);
      }
    }

    async function copyToClipboard(text) {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
      const input = document.createElement('input');
      input.value = text;
      input.setAttribute('readonly', 'readonly');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(input);
      return ok;
    }

    button.addEventListener('click', async () => {
      const title = button.getAttribute('data-title') || document.title;
      const url = button.getAttribute('data-url') || window.location.href;

      try {
        if (navigator.share) {
          await navigator.share({ title, url });
          return;
        }
      } catch (e) {
        // 用户取消分享不提示错误
        return;
      }

      try {
        const ok = await copyToClipboard(url);
        setStatus(ok ? 'Link copied' : 'Copy failed');
      } catch (e) {
        setStatus('Copy failed');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
